import { render, staticRenderFns } from "./MySales.vue?vue&type=template&id=07208e9e&scoped=true&"
import script from "./MySales.vue?vue&type=script&lang=js&"
export * from "./MySales.vue?vue&type=script&lang=js&"
import style0 from "./MySales.vue?vue&type=style&index=0&id=07208e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07208e9e",
  null
  
)

export default component.exports